module.exports = __webpack_public_path__ + "img/item16.bb2a46af.png";